import React from 'react';
import TopBar from '../../../Components/TopBar';
import Page from '../../../Components/Containers/Page';
import Form, { Actions, RequiredValidator, Wysiwyg, parseSettingsToData } from '../../../Components/Form';
import Tabs, {Tab} from '../../../Components/Containers/Tabs/Tabs';
import { useSettings } from '../../../Data/Settings';
import AlertBadge from '../../../Components/Icons/AlertBadge';
import { useDialogues } from '../../../Components/Dialogues';

const DocumentTemplates = () => {
    const {settings: customerSettings, update: customerUpdate} = useSettings('/customers/settings', 'Document templates updated');
    const {settings: quoteSettings, update: quoteUpdate} = useSettings('/quotes/settings', 'Document templates updated');

    return <>
        <TopBar left="BackBtn" title="Document templates" />

        <Page>
            <Tabs>
                <Tab title="Invoice">
                    <Inner settings={customerSettings}
                        update={customerUpdate}
                        filter={['Customers:InvoiceHeader', 'Customers:InvoiceFooter']}
                        title="Invoice"
                    />
                </Tab>
                <Tab title="Quotes">
                    <Inner settings={quoteSettings}
                        update={quoteUpdate}
                        filter={['Quotes:ItemisationHeader', 'Quotes:ItemisationFooter']}
                        title="Quote"
                    />
                </Tab>
                <Tab title="Itemisation">
                    <Inner settings={customerSettings}
                        update={customerUpdate}
                        filter={['Customers:ItemisationHeader', 'Customers:ItemisationFooter']}
                        title="Itemisation"
                    />
                </Tab>
            </Tabs>
        </Page>
    </>
}

const Inner = ({settings, filter, update, title}) => {
    const {info} = useDialogues();

    if (settings === null) {
        return null;
    }

    const header = settings.find(setting => setting.key === filter[0]);
    const footer = settings.find(setting => setting.key === filter[1]);
    const boxStyles = 'bg-gray-50 border border-dashed border-gray-400 text-gray-400 text-center font-bold py-3';

    const helpBtn = (topic) => {
        return <AlertBadge icon="Question"
            theme="secondary"
            size="small"
            className="ml-3"
            inline
            onClick={() => {
                const messages = {
                    'Logo': `Your logo will automatically be shown here.\n\nYou can upload a new logo in the Business Details page.`,
                    'Address': `Your business address will automatically be shown here.\n\nYou can change your address in the Business Details page.`,
                    'Documents': `Documents linked with the services relevant to the ${title.toLowerCase()} will automatically be shown here.\n\nYou can manage these in the Documents page.\n(Pro plan only).`,
                }
                messages[`${title} Items`] = `The line items for this ${title.toLowerCase()} will automatically be shown here.\n\nThese items are managed on the ${title === 'Quotes' ? 'quote' : 'customer job'}.`;

                info({title: topic, message: messages[topic]})
            }}
        />
    }

    return <Form data={parseSettingsToData(settings, filter)} onSubmit={update} waitForData>
        <div className="w-full flex justify-between">
            <div className={`w-[45%] ${boxStyles}`}>
                LOGO {helpBtn('Logo')}
            </div>
            <div className={`w-[45%] ${boxStyles}`}>
                BUSINESS ADDRESS {helpBtn('Address')}
            </div>
        </div>

        <Wysiwyg key={header.key}
            name={header.key}
            label={header.label}
            validators={[RequiredValidator]}
            features={['mergetags', 'basicFormatting', 'images']}
            imageTags={[{name: 'DocumentImage', value: 'DocumentImage'}]}
            mode="html"
            bottomMargin="50"
        />

        <div className={`w-full ${boxStyles}`}>
            {title.toUpperCase()} ITEMS  {helpBtn(`${title} Items`)}
        </div>

        <Wysiwyg key={footer.key}
            name={footer.key}
            label={footer.label}
            validators={[RequiredValidator]}
            features={['mergetags', 'basicFormatting', 'images']}
            imageTags={[{name: 'DocumentImage', value: 'DocumentImage'}]}
            mode="html"
            bottomMargin="50"
        />

        {<div className={`w-full ${boxStyles}`}>
            LINKED DOCUMENTS {helpBtn('Documents')}
        </div>}

        <Actions submit={{label: 'Save'}} />
    </Form>
}

export default DocumentTemplates;
